<script setup lang="ts">
import { useAuthStore } from "@/store/authstore";
import UserMenu from "../menu/UserMenu.vue";
import { useRoute } from "vue-router";
import logo from "@/assets/letfaktura.png";

const route = useRoute();
const authStore = useAuthStore();
</script>

<template>
  <v-app-bar flat class="nav-bar" height="64">
    <v-container class="nav-inner d-flex align-center" max-width="1280">
      <router-link to="/" aria-label="Gå til forsiden" class="nav-logo-link">
        <v-img :src="logo" alt="letfaktura" :width="140" :height="36" />
      </router-link>
      <nav v-if="authStore.user" class="nav-links">
        <router-link to="/home" class="nav-link" :class="{ active: route.name === 'Home' }">
          Oversigt
        </router-link>
        <router-link to="/invoices" class="nav-link" :class="{ active: route.name === 'Invoices' }">
          Fakturaer
        </router-link>
        <router-link to="/expenses" class="nav-link" :class="{ active: route.name === 'Expenses' }">
          Køb
        </router-link>
      </nav>
      <v-spacer />
      <v-btn
        v-if="!authStore.user && route.name !== 'Login'"
        to="/login"
        color="primary"
        variant="flat"
        size="default"
        class="nav-btn"
      >
        Log ind
      </v-btn>
      <UserMenu v-else-if="authStore.user" />
    </v-container>
  </v-app-bar>
</template>

<style scoped>
.nav-bar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.07) !important;
  background: rgba(255, 255, 255, 0.96) !important;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}
.nav-inner {
  width: 100%;
  padding-left: 24px !important;
  padding-right: 24px !important;
}
.nav-logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
}
.nav-links {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 28px;
}
.nav-link {
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 0.88rem;
  font-weight: 500;
  color: #64748b;
  text-decoration: none;
  transition: background 0.15s ease, color 0.15s ease;
}
.nav-link:hover {
  background: #f1f5f9;
  color: #0f172a;
}
.nav-link.active {
  background: rgba(21, 101, 192, 0.1);
  color: #1565c0;
  font-weight: 600;
}
.nav-btn {
  font-weight: 500;
  letter-spacing: 0.01em;
  padding: 0 20px;
}
</style>
